var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import getIcon from '../../utils/getIcon';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  margin: ", ";\n  color: ", ";\n  font-size: ", ";\n  visibility: ", ";\n  cursor: ", ";\n  user-select: none;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  margin: ", ";\n  color: ", ";\n  font-size: ", ";\n  visibility: ", ";\n  cursor: ", ";\n  user-select: none;\n"])), function (_a) {
    var component = _a.theme.component;
    return component.pagination.height;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.base.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.fontSize.label;
}, function (_a) {
    var visible = _a.visible;
    return (visible ? 'visible' : 'hidden');
}, function (_a) {
    var visible = _a.visible;
    return (visible ? 'pointer' : 'auto');
});
var ArrowMediumLeft = getIcon('ArrowMediumLeft');
var StyledArrowMediumLeft = styled(ArrowMediumLeft)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 0.25rem;\n  font-size: ", ";\n  color: ", ";\n  fill: ", ";\n"], ["\n  margin-right: 0.25rem;\n  font-size: ", ";\n  color: ", ";\n  fill: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.pagination.fontSize.label;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.base.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.base.color;
});
var ArrowMediumRight = getIcon('ArrowMediumRight');
var StyledArrowMediumRight = styled(ArrowMediumRight)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 0.25rem;\n  font-size: ", ";\n  color: ", ";\n  fill: ", ";\n"], ["\n  margin-left: 0.25rem;\n  font-size: ", ";\n  color: ", ";\n  fill: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.pagination.fontSize.label;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.base.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.base.color;
});
var Label = function (_a) {
    var children = _a.children, visible = _a.visible, next = _a.next, onClick = _a.onClick, previous = _a.previous;
    return (React.createElement(Wrapper, { "data-testid": "pagination-" + (previous ? 'prev' : 'next'), onClick: onClick, visible: visible },
        previous && (React.createElement("span", null,
            React.createElement(StyledArrowMediumLeft, null))),
        children,
        next && (React.createElement("span", null,
            React.createElement(StyledArrowMediumRight, null)))));
};
export default Label;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map